<template>
  <div>
    <section class="hero is-white">
      <div class="hero-body">
        <div class="breadcrumb-wrapper">
          <img src="@/assets/images/icons/icon-home.png" alt="" class="icon-home">
          <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/index">Trang chủ</router-link></li>
              <li class="is-active"><a>Admin</a></li>
            </ul>
          </nav>
        </div>
        <div class="container">
          <admin-menu :activeLink="'/dkkh'"/>
          <div class="signup form-register no-margin">
            <h1 class="title is-4">Tạo tài khoản vận hành mới</h1>
            <form @submit.prevent="validateBeforeSubmit">

              <div class="columns">
                <div class="column">
                  <b-field
                    label="Tên đăng nhập"
                    :type="{'is-danger': errors.has('username')}"
                    :message="errors.first('username')"
                    custom-class="has-text-weight-normal"
                  >
                    <b-input
                      v-model="username"
                      name="username"
                      v-validate="{required: true, regex: /^[A-Za-z0-9]+(?:[_-][A-Za-z0-9]+)*$/, min: 4, max: 32}"
                      size="is-medium"
                      data-vv-as="Tên đăng nhập"
                    ></b-input>
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <b-field
                    label="Tên"
                    :type="{'is-danger': errors.has('firstName')}"
                    :message="errors.first('firstName')"
                    custom-class="has-text-weight-normal"
                  >
                    <b-input
                      v-model="firstName"
                      name="firstName"
                      v-validate="'required'"
                      size="is-medium"
                      data-vv-as="Tên"
                    ></b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field
                    label="Họ"
                    :type="{'is-danger': errors.has('lastName')}"
                    :message="errors.first('lastName')"
                    custom-class="has-text-weight-normal"
                  >
                    <b-input
                      v-model="lastName"
                      name="lastName"
                      v-validate="'required'"
                      size="is-medium"
                      data-vv-as="Họ"
                    ></b-input>
                  </b-field>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <b-field
                    label="Công ty"
                    :type="{'is-danger': errors.has('company')}"
                    :message="errors.first('company')"
                    custom-class="has-text-weight-normal"
                  >
                    <b-input
                      v-model="company"
                      name="company"
                      v-validate="'required'"
                      size="is-medium"
                      data-vv-as="Công ty"
                    ></b-input>
                  </b-field>
                </div>

                <div class="column">
                  <b-field
                    label="Điện thoại"
                    :type="{'is-danger': errors.has('phone')}"
                    :message="errors.first('phone')"
                    custom-class="has-text-weight-normal"
                  >
                    <b-input
                      v-model="phone"
                      name="phone"
                      v-validate="{required: true, regex: /^[0-9]{10,11}$/}"
                      size="is-medium"
                      data-vv-as="Điện thoại"
                    ></b-input>
                  </b-field>
                </div>

              </div>



              <div class="columns">
                <div class="column">
                  <b-field
                    label="Email công ty"
                    :type="{'is-danger': errors.has('email')}"
                    :message="errors.first('email')"
                    custom-class="has-text-weight-normal"
                  >
                    <b-input
                      v-model="email"
                      name="email"
                      v-validate="'required|email'"
                      size="is-medium"
                      data-vv-as="Email công ty"
                    ></b-input>
                  </b-field>
                </div>

                <!-- <div class="column">
                  <b-field 
                    label="Tỉnh/Thành phố"
                    :type="{'is-danger': errors.has('province')}"
                    :message="errors.first('province')"
                    >
                    <b-select 
                      v-model="province" 
                      placeholder="Chọn tỉnh thành"
                      v-validate="'required'"
                      name="province"
                      >
                      <option
                          v-for="option in provincesSelect"
                          :value="option"
                          :key="option">
                          {{ option }}
                      </option>
                    </b-select>
                  </b-field>
                </div> -->
              </div>


              <div class="columns">
                <div class="column">
                  <b-field
                    label="Mật khẩu"
                    :type="{'is-danger': errors.has('password')}"
                    :message="errors.first('password')"
                    custom-class="has-text-weight-normal"
                  >
                    <b-input
                      v-model="password"
                      type="password"
                      name="password"
                      v-validate="{required: true, regex: /\w/, min: 8}"
                      size="is-medium"
                      data-vv-as="Mật khẩu"
                    ></b-input>
                  </b-field>
                </div>

                <div class="column">
                  <b-field
                    label="Xác nhận mật khẩu"
                    :type="{'is-danger': errors.has('confirm-password')}"
                    :message="errors.first('confirm-password')"
                    custom-class="has-text-weight-normal"
                  >
                    <b-input
                      v-model="confirmPassword"
                      v-validate="{ required: true, is: password }"
                      type="password"
                      name="confirm-password"
                      size="is-medium"
                      data-vv-as="Xác nhận mật khẩu"
                    ></b-input>
                  </b-field>
                </div>
              </div>


              
              

              <!-- <div class="form-captcha">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="onCaptchaVerified"
                  @expired="onCaptchaExpired"
                  sitekey="6LfvfM8UAAAAANxG5gmTEO8A7ticNHd8tIZYu0K4">
                </vue-recaptcha>
              </div> -->


              <div class="field is-grouped is-grouped-centered">
                <div class="control">
                  <button class="button" @click="resetData">Nhập lại</button>
                </div>
                <div class="control">
                  <button 
                  type="submit" 
                  class="button is-info"
                  :class="{'is-loading': isLoaded}"
                  :disabled="isLoaded"
                  >Đăng ký</button>
                </div>
              </div>
            </form>
            <b-modal :active.sync="isSuccessActive" has-modal-card>
              <div class="modal-card">
                <section class="modal-card-body">
                  <h2 class="title is-4" style="text-align: center">Đăng ký thành công!</h2>
                  <div class="is-grouped-centered">
                    <p>Đăng ký thành công với tên đăng nhập: <strong>{{registerName}}</strong></p>
                  </div>
                </section>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import UsersService from "@/services/UsersService";

export default {
  name: "NewUser",
  data() {
    return {
      username: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      email: "",
      phone: "",
      company: "",
      province: "",
      isSuccessActive: false,

      isLoaded: false,

      // recaptchaToken: '',

      // provincesSelect: provinces.provinces,

      registerName: ''
    };
  },
  components: {
    AdminMenu: () => import("../components/Admin/AdminMenu")
  },
  methods: {
    signUp() {
      const self = this
      // if(this.recaptchaToken == '') {
      //   alert("Please verify you are not a robot")
      //   return
      // }
      this.isLoaded = true;
      UsersService.signUpByAdmin({
        user: {
          username: this.username,
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password,
          email: this.email,
          phone: this.phone,
          company: this.company
        }
      },
      self.$store.state.auth.token
      )
        .then(res => {
          if (res.data.status) {
            this.registerName = this.username;
            this.isSuccessActive = true;
            this.resetData();
            this.$nextTick(() => {
              this.$validator.reset();
            });
          } else {
            if(res.data.message && res.data.message.includes('user already exists.')) {
              res.data.message = 'Người dùng đã tồn tại.'
            }
            this.$toast.open({
              message: res.data.message || "Lỗi máy chủ. Vui lòng thử lại",
              type: "is-danger"
            });
          }
        })
        .catch(() => {
          this.$toast.open({
            message: "Lỗi máy chủ. Vui lòng thử lại",
            type: "is-info"
          });
        })
        .finally(() => {
          this.isLoaded = false;
        });
    },
    resetData() {
      this.username = "";
      this.firstName = "";
      this.lastName = "";
      this.password = "";
      this.confirmPassword = "";
      this.phone = "";
      this.email = "";
      this.company = "";
      this.provice = "";
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.signUp();
        }
      });
    },
    // onCaptchaExpired: function () {
    //   this.$refs.recaptcha.reset();
    // },
    // onCaptchaVerified(recaptchaToken) {
    //   this.recaptchaToken = recaptchaToken
    // }
  }
};
</script>
<style lang="scss" scope>
  .signup {
    font-family: Roboto,Arial,Helvetica,sans-serif;
  }

  .form-register {
    max-width: 600px;
    margin: 50px auto;

    .title {
      text-align: center;
    }

    .columns {
      margin-bottom: 10px;
    }

    .form-captcha {
      margin-bottom: 25px;
      display: flex;
      justify-content: center;
    }

    &.no-margin {
      margin-top: 0;
    }
  }
</style>
